import { render, staticRenderFns } from "./ShowcaseItem.vue?vue&type=template&id=0d4c480f&"
import script from "./ShowcaseItem.vue?vue&type=script&lang=js&"
export * from "./ShowcaseItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports